import React from "react";
import PropTypes from "prop-types";
import PointForm from "./PointForm";
import Objects from "../../../utils/Objects";

// import Notify from "../../services/Notify";

class PointFormList extends React.Component {

  constructor(props) {
    super(props);
    this.state = {entity: props.defaultValue, setValue: props.setValue};
  }

  newState(props) {
    this.setState({entity: props.defaultValue, setValue: props.setValue});
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.defaultValue !== this.props.defaultValue) {
      this.newState(nextProps);
    }
  }

  addPoint(index, point) {
    const {setValue, entity = []} = this.state;
    if (Objects.isNullOrUndefined(index)) {
      entity.push(point);
    } else {
      entity[index] = point;
    }

    setValue && setValue(entity);
    this.setState({entity, newPoint: {}});
  }

  render() {
    const {entity = [], newPoint = {}} = this.state;
    return (
        <div>
          <PointForm defaultValue={newPoint} index={null} setValue={point => this.addPoint(null, point)}/>
          {entity.map((point, index) =>
              <PointForm key={index} index={index} defaultValue={point} setValue={point => this.addPoint(index, point)}/>
          )}
        </div>
    );
  }
}

PointFormList.propTypes = {
  setValue: PropTypes.func.isRequired,
  defaultValue: PropTypes.array
};

export default PointFormList;



// WEBPACK FOOTER //
// ./src/map/polygon/point/PointFormList.js